export default "__VITE_ASSET__CTXv_Xgn__"